<div (window:resize)="onResize($event)" (mouseenter) ="mouseEnter()">

    <div class="container-fluid">
        <!--<div class="row">
        <div class="col-md-12">
            <label>Type: </label>
        </div>
    </div>
    <div class="row">
        <div class="col-md-12">
            <select>
                <option selected="selected" class="option">Regular</option>
                <option class="option">360</option>
            </select>
        </div>
    </div>-->

        <div class="btns-container" style="position:absolute;top:7px;right:1px;">
            <!--<a (click)="assign()" class="d-none d-sm-inline-block btn btn-sm btn-other shadow-sm margin-right-5" [ngClass]="{'btn-other': canAssign, 'btn-gray': !canAssign}">
            <i class="fas fa-user-alt text-white-50"> <span class="button-text">Assign</span></i>
        </a>-->
            <a (click)="openModal()" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm">
                <i class="fas fa-plus text-white-50"> <span class="button-text">Purchase</span></i>
            </a>
        </div>

        <ng-container *ngIf="loading">
            <div class="loading text-center">
                <br />
                <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
                <br />
                <p>Loading, please wait...</p>
            </div>
        </ng-container>

        <div class="row" *ngIf="!loading">

            <div>
                <ul class="nav nav-tabs availableTabs">
                    <li (click)="tabSelected(0.1)" class="active"><a data-toggle="tab" href="#Tab1">ELI - Self Assessment</a></li>
                    <li (click)="tabSelected(0.2)"><a data-toggle="tab" href="#Tab2">ELI 360</a></li>
                </ul>
            </div>

            <div class="tab-content availableTabs">
                <div id="Tab1" class="tab-pane fade in active">
                    <!--<br />-->

                    <div style="width: 100%; max-height: 400px; height:400px;">
                        <ag-grid-angular #agGrid
                                         style="width: 100%; height: 100%;"
                                         class="ag-theme-balham"
                                         [enableFilter]="true"
                                         [gridOptions]="gridOptions"
                                         [rowData]="_Globals.availableAsessmentsRegular"
                                         [columnDefs]="assessmentsHeaders"
                                         [enableSorting]="true"
                                         [floatingFilter]="true"
                                         [enableColResize]="true"
                                         (rowClicked)="onRowClicked($event)"
                                         (gridReady)="onGridReady(1, $event)"
                                         [pagination]="true"
                                         [paginationPageSize]="25"
                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                         (selectionChanged)="onSelectionChangedChoiceSet($event)">
                        </ag-grid-angular>
                    </div>
                </div>

                <div id="Tab2" class="tab-pane fade">
                    <!--<br />-->

                    <div style="width: 100%; max-height: 400px; height:400px;">
                        <ag-grid-angular #agGrid
                                         style="width: 100%; height: 100%;"
                                         class="ag-theme-balham"
                                         [enableFilter]="true"
                                         [gridOptions]="gridOptions"
                                         [rowData]="_Globals.availableAsessments360"
                                         [columnDefs]="assessmentsHeaders"
                                         [enableSorting]="true"
                                         [floatingFilter]="true"
                                         [enableColResize]="true"
                                         (rowClicked)="onRowClicked($event)"
                                         (gridReady)="onGridReady(2, $event)"
                                         [pagination]="true"
                                         [paginationPageSize]="25"
                                         [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                                         (selectionChanged)="onSelectionChangedChoiceSet($event)">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-purchase-assessment-modal #purchaseAssessment></app-purchase-assessment-modal>
<app-assign-assesments-new-modal #assignAssessmentNew></app-assign-assesments-new-modal>